import { buttonClasses, SxProps } from '@mui/material'
import { ButtonColors } from './Button.types'

interface ButtonStyles {
  button: SxProps
  text: SxProps
  small: SxProps
  large: SxProps
  noBorders: SxProps
}

export const buttonColors: ButtonColors = {
  backgroundPrimary: '#171919',
  backgroundSecondary: '#FFFFFF',
  border: 'rgba(255, 255, 255, 0.12)',
  borderSecondary: '#D5D7DA',
  borderDisabled: '#E9EAEB',
  backgroundDisabled: '#F5F5F5',
  hoverPrimary: '#181D27',
  hoverSecondary: '#FAFAFA',
  hoverTertiary: '#FAFAFA',
  textSecondary: '#414651',
  textTertiary: '#535862',
  textDisabledSecondary: '#A4A7AE',
  textDisabled: '#283544',
  backgroundWarmIvory: '#FFF6E7',
  borderWarmIvory: '#FFF6E7',
  hoverWarmIvory: '#FFF4E5',
  textWarmIvory: '#171919',
}

export const buttonStyles: ButtonStyles = {
  button: {
    borderRadius: 3,
    boxShadow: 'none',
    px: 2.25,
    py: 1.25,
    textTransform: 'capitalize',
    border: '2px solid',

    '&:hover': {
      boxShadow: 'none',
    },

    [`&.${buttonClasses.colorPrimary}`]: {
      bgcolor: 'button.backgroundPrimary',
      borderColor: 'button.border',
      color: 'pageTheme.textColor',

      '&:hover': {
        bgcolor: 'button.hoverPrimary',
      },

      [`&.${buttonClasses.disabled}`]: {
        color: 'button.textDisabledSecondary',
      },

      [`&.${buttonClasses.loading}`]: {
        bgcolor: 'button.backgroundPrimary',
        borderColor: 'button.border',
        color: 'transparent',
      },
    },

    [`&.${buttonClasses.colorSecondary}`]: {
      bgcolor: 'button.backgroundSecondary',
      borderColor: 'button.borderSecondary',
      color: 'button.textSecondary',

      '&:hover': {
        bgcolor: 'button.hoverSecondary',
      },

      [`&.${buttonClasses.disabled}`]: {
        bgcolor: 'button.backgroundSecondary',
        color: 'button.textDisabledSecondary',
      },

      [`&.${buttonClasses.loading}`]: {
        color: 'transparent',
      },
    },

    [`&.MuiButton-colorTertiary`]: {
      bgcolor: 'transparent',
      borderColor: 'transparent',
      color: 'button.textTertiary',

      '&:hover': {
        bgcolor: 'button.hoverTertiary',
      },

      [`&.${buttonClasses.disabled}`]: {
        bgcolor: 'transparent',
        borderColor: 'transparent',
        color: 'button.textDisabledSecondary',
      },

      [`&.${buttonClasses.loading}`]: {
        color: 'transparent',
      },
    },

    [`&.MuiButton-colorWarmIvory`]: {
      bgcolor: 'button.backgroundWarmIvory',
      borderColor: 'button.borderWarmIvory',
      color: 'button.textWarmIvory',

      '&:hover': {
        bgcolor: 'button.hoverWarmIvory',
      },

      [`&.${buttonClasses.disabled}`]: {
        bgcolor: 'button.backgroundDisabled',
        borderColor: 'button.borderDisabled',
        color: 'button.textDisabledSecondary',
      },

      [`&.${buttonClasses.loading}`]: {
        color: 'transparent',
      },
    },

    [`&.MuiButton-colorTransparentOutlined`]: {
      bgcolor: 'transparent',
      borderColor: 'pageTheme.secondaryColor',
      borderWidth: 1,
      borderRadius: 2,
      color: 'pageTheme.secondaryColor',

      '&:hover': {
        bgcolor: 'rgba(255, 255, 255, 0.1)',
        borderColor: 'rgba(255, 255, 255, 0.75)',
      },

      [`&.${buttonClasses.disabled}`]: {
        bgcolor: 'transparent',
        borderColor: 'button.borderDisabled',
        color: 'button.textDisabledSecondary',
      },

      [`&.${buttonClasses.loading}`]: {
        color: 'transparent',
      },
    },

    [`&.${buttonClasses.colorError}`]: {
      borderColor: 'error.main',

      '&:hover': {
        borderColor: 'error.dark',
      },

      [`&.${buttonClasses.disabled}`]: {
        borderColor: 'transparent',
      },
    },

    [`&.${buttonClasses.disabled}`]: {
      borderColor: 'button.borderDisabled',
      bgcolor: 'button.backgroundDisabled',
    },

    [`&.${buttonClasses.loading}`]: {
      [`.${buttonClasses.loadingIndicator}`]: {
        '> .MuiBox-root': {
          display: 'flex',
        },
      },
    },
  },
  text: {
    typography: 'textMdSemibold',
  },
  small: {
    py: 1,
  },
  large: {
    py: 2,
  },
  noBorders: {
    borderWidth: 0,
  },
}
